// ═══════════════════════════════════════════════════════════════════════════
// Código postal → entidad federativa
//
// En México los dos primeros dígitos del CP determinan el estado. Eso vuelve
// al CP el ANCLA del parser de direcciones: en vez de adivinar el estado por
// posición en el texto, se deduce con certeza.
//
// ⚠ ALCANCE DE LA VERIFICACIÓN: los prefijos marcados ✔ están confirmados
//   contra los 110 clientes reales con domicilio. El resto sigue el catálogo
//   estándar de SEPOMEX pero NO está verificado con datos propios. Cuando el
//   catálogo SEPOMEX viva en Postgres (Etapa 4) esta tabla se retira: ahí
//   habrá además municipio y colonias por CP.
// ═══════════════════════════════════════════════════════════════════════════

const RANGOS = [
  [["01", "16"], "Ciudad de México"],      // ✔
  [["20", "20"], "Aguascalientes"],
  [["21", "22"], "Baja California"],       // ✔
  [["23", "23"], "Baja California Sur"],
  [["24", "24"], "Campeche"],
  [["25", "27"], "Coahuila"],              // ✔
  [["28", "28"], "Colima"],
  [["29", "30"], "Chiapas"],
  [["31", "33"], "Chihuahua"],             // ✔
  [["34", "35"], "Durango"],
  [["36", "38"], "Guanajuato"],            // ✔
  [["39", "41"], "Guerrero"],
  [["42", "43"], "Hidalgo"],
  [["44", "49"], "Jalisco"],               // ✔
  [["50", "57"], "México"],                // ✔
  [["58", "61"], "Michoacán"],             // ✔
  [["62", "62"], "Morelos"],
  [["63", "63"], "Nayarit"],
  [["64", "67"], "Nuevo León"],            // ✔
  [["68", "71"], "Oaxaca"],
  [["72", "75"], "Puebla"],                // ✔
  [["76", "76"], "Querétaro"],             // ✔
  [["77", "77"], "Quintana Roo"],          // ✔
  [["78", "79"], "San Luis Potosí"],
  [["80", "82"], "Sinaloa"],
  [["83", "85"], "Sonora"],                // ✔
  [["86", "86"], "Tabasco"],
  [["87", "89"], "Tamaulipas"],
  [["90", "90"], "Tlaxcala"],
  [["91", "96"], "Veracruz"],              // ✔
  [["97", "97"], "Yucatán"],
  [["98", "99"], "Zacatecas"],
];

/** Estado a partir del CP. Devuelve "" si el CP no es válido. */
export function estadoPorCP(cp) {
  const limpio = String(cp || "").replace(/\D/g, "");
  if (limpio.length !== 5) return "";
  const pre = limpio.slice(0, 2);
  for (const [[desde, hasta], estado] of RANGOS) {
    if (pre >= desde && pre <= hasta) return estado;
  }
  return "";
}

/** ¿Es un CP mexicano plausible? */
export function esCPValido(cp) {
  return /^\d{5}$/.test(String(cp || "").trim()) && estadoPorCP(cp) !== "";
}

/**
 * Compara dos nombres de estado ignorando acentos, mayúsculas y variantes
 * comunes ("CDMX" = "Ciudad de México"). Sirve para avisar de discrepancias
 * sin cambiar lo que el usuario escribió.
 */
export function mismoEstado(a, b) {
  const n = (s) => String(s || "").toLowerCase()
    .normalize("NFD").replace(/[̀-ͯ]/g, "")
    .replace(/\b(estado de|edo\.? de)\b/g, "")
    .replace(/[^a-z]/g, "")
    .replace(/^cdmx$|^df$|^distritofederal$/, "ciudaddemexico")
    .replace(/^bc$/, "bajacalifornia")
    .replace(/^bcs$/, "bajacaliforniasur")
    .replace(/^nl$/, "nuevoleon")
    .replace(/^qroo$|^quintanaroo$/, "quintanaroo");
  return n(a) === n(b);
}
